import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from "react-router-dom";
import Sidebar from '../components/Sidebar';
import { FaDownload, FaPhoneAlt, FaEnvelope, FaCreditCard, FaFileUpload } from 'react-icons/fa';
import { showError, showSuccess } from "../utils/toast"; // adjust path




const PolicyViewPage = () => {
  const [activeTab, setActiveTab] = useState("overview");
  const { customerId, policyId, policyNumber } = useParams();
  const [policy, setPolicy] = useState(null);



  useEffect(() => {
    if (customerId && policyId) {
      fetchPolicy();
    }
  }, [customerId, policyId]);

  const fetchPolicy = async () => {
    try {
      const res = await fetch(`${import.meta.env.VITE_API_URL}/v1/customer/${customerId}/${policyId}/${policyNumber}`);

      if (!res.ok) {
        throw new Error(`Error: ${res.status}`);
      }

      const data = await res.json();
      console.log("data", data.policy)
      setPolicy(data.policy || null);
    } catch (err) {
      console.error("❌ Error fetching policy:", err);
    }
  };

  const documents = [
    { title: "Policy Certificate", type: "PDF Document", date: "Jan 15, 2024", size: "2.3 MB" },
    { title: "Terms & Conditions", type: "PDF Document", date: "Jan 15, 2024", size: "1.8 MB" },
    { title: "Premium Receipt", type: "PDF Document", date: "Feb 10, 2024", size: "0.5 MB" }
  ];

  return (
    <div className="dashboard-layout policy-view-modern">
      <Sidebar />
      <div className="main-content">
        {/* Back Button */}
        <div className="back-navigation">
          <button onClick={() => navigate('/customer/mypolicies')} className="back-btn">
            <i className="bi bi-arrow-left"></i>
            Back to Policies
          </button>
        </div>

        {/* Policy Header Card */}
        <div className="policy-header-card">
          <div className="policy-main-info">
            <div className="policy-title-section">
              <h1 className="policy-title">{policy?.productName || 'Health Insurance Premium Plan'}</h1>
              <div className="policy-meta">
                <span className="company-badge">
                  <i className="bi bi-building"></i>
                  {policy?.productName || 'Blue Cross Blue Shield'}
                </span>
                <span className="policy-id">
                  <i className="bi bi-file-earmark"></i>
                  {policy?.policyNumber || 'POL-2024-001'}
                </span>
                <span className="status-badge active">
                  {policy?.status || 'Active'}
                </span>
              </div>
            </div>

            <div className="policy-details-grid">
              <div className="detail-item">
                <i className="bi bi-calendar3"></i>
                <div>
                  <span className="detail-label">Policy Period</span>
                  <span className="detail-value">{policy?.policyPeriod || '1/1/2024 to 12/31/2024'}</span>
                </div>
              </div>
              <div className="detail-item">
                <i className="bi bi-currency-dollar"></i>
                <div>
                  <span className="detail-label">Premium</span>
                  <span className="detail-value">₹{policy?.premiumAmount || '450.00'} / Annual</span>
                </div>
              </div>
            </div>
          </div>

          <div className="due-payment-card">
            <div className="due-header">
              <i className="bi bi-calendar-check"></i>
              <span>Next Payment Due</span>
            </div>
            <div className="due-date">
              {policy?.endDate || '3/15/2024'}
            </div>
            <div className="action-required">
              Action Required
            </div>
          </div>
        </div>

        {/* Navigation Tabs */}
        <div className="policy-nav-tabs">
          <button 
            className={activeTab === "overview" ? "nav-tab active" : "nav-tab"} 
            onClick={() => setActiveTab("overview")}
          >
            Overview
          </button>
          <button 
            className={activeTab === "documents" ? "nav-tab active" : "nav-tab"} 
            onClick={() => setActiveTab("documents")}
          >
            Documents
          </button>
          <button 
            className={activeTab === "history" ? "nav-tab active" : "nav-tab"} 
            onClick={() => setActiveTab("history")}
          >
            Payment History
          </button>
        </div>

        {/* Content Area */}
        <div className="policy-content">
          {activeTab === "overview" && (
            <div className="overview-layout">
              <div className="main-content-area">
               {/* Policyholder Details */}
                <div className="content-card">
                  <div className="card-header">
                    <i className="bi bi-person-fill"></i>
                    <h3>Policyholder Details</h3>
                  </div>
                  <div className="card-content">
                    <div className="detail-grid two-column">
                      <div className="detail-row">
                        <span className="label">Full Name</span>
                        <span className="value">{policy?.policyHolderName || 'John Doe'}</span>
                      </div>
                      <div className="detail-row">
                        <span className="label">Email</span>
                        <span className="value">{policy?.policyHolderEmail || 'john.doe@email.com'}</span>
                      </div>
                      <div className="detail-row">
                        <span className="label">Phone</span>
                        <span className="value">{policy?.policyHolderPhone || '+1 (555) 123-4567'}</span>
                      </div>
                      <div className="detail-row">
                        <span className="label">Address</span>
                        <span className="value">{policy?.policyHolderAddress || '123 Main St, Anytown, ST 12345'}</span>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Covered Members */}
                <div className="content-card">
                  <div className="card-header">
                    <i className="bi bi-people-fill"></i>
                    <h3>Covered Members</h3>
                  </div>
                  <div className="card-content">
                    <div className="members-list">
                      {policy?.insuredMembers && policy.insuredMembers.length > 0 ? (
                        policy.insuredMembers.map((member, index) => (
                          <div key={index} className="member-card">
                            <div className="member-info">
                              <div className="member-name">{member.insuredName || 'John Doe'}</div>
                              <div className="member-relation">{member.relationship || 'Self'}</div>
                            </div>
                            <div className="member-dob">
                              <span className="dob-label">Date of Birth</span>
                              <span className="dob-value">{member.dob || '6/15/1985'}</span>
                            </div>
                          </div>
                        ))
                      ) : (
                        <>
                          <div className="member-card">
                            <div className="member-info">
                              <div className="member-name">John Doe</div>
                              <div className="member-relation">Self</div>
                            </div>
                            <div className="member-dob">
                              <span className="dob-label">Date of Birth</span>
                              <span className="dob-value">6/15/1985</span>
                            </div>
                          </div>
                          <div className="member-card">
                            <div className="member-info">
                              <div className="member-name">Jane Doe</div>
                              <div className="member-relation">Spouse</div>
                            </div>
                            <div className="member-dob">
                              <span className="dob-label">Date of Birth</span>
                              <span className="dob-value">8/22/1987</span>
                            </div>
                          </div>
                          <div className="member-card">
                            <div className="member-info">
                              <div className="member-name">Mike Doe</div>
                              <div className="member-relation">Child</div>
                            </div>
                            <div className="member-dob">
                              <span className="dob-label">Date of Birth</span>
                              <span className="dob-value">3/10/2015</span>
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </div>


                {/* Agent & Company Details */}
                <div className="Agent__companyCard">

                  <div className="content-card">
                    <div className="card-header">
                      <i className="bi bi-building"></i>
                      <h3>Agent & Company Details</h3>
                    </div>
                    <div className="card-content">
                      <div className="agent-company-grid">

                        {/* Left Column - Company Info */}
                        <div className="agent-section">
                          <div className="detail-row with-icon">
                            <i className="bi bi-buildings"></i>
                            <div>
                              <span className="label">Insurance Company</span>
                              <span className="value">{policy?.productName || 'Blue Cross Blue Shield'}</span>
                            </div>
                          </div>
                          <div className="detail-row with-icon">
                            <i className="bi bi-shield-check"></i>
                            <div>
                              <span className="label">Policy Type</span>
                              <span className="value">{policy?.policyType || 'Health Insurance'}</span>
                            </div>
                          </div>
                        </div>

                        {/* Right Column - Agent Info */}
                        <div className="company-section">
                          <div className="detail-row with-icon">
                            <i className="bi bi-person-badge"></i>
                            <div>
                              <span className="label">Agent Name</span>
                              <span className="value">{policy?.agentName || 'Sarah Wilson'}</span>
                            </div>
                          </div>
                          <div className="detail-row with-icon">
                            <i className="bi bi-telephone"></i>
                            <div>
                              <span className="label">Agent Contact</span>
                              <span className="value contact-info">
                                <span>{policy?.agentEmail || 'sarah.wilson@insurance.com'}</span>
                                <span>{policy?.agentPhone || '+1 (555) 987-6543'}</span>
                              </span>
                            </div>
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>

              </div>

              {/* Sidebar - Quick Actions */}
              <div className="sidebar-content">
                <div className="quick-actions-card">
                  <div className="card-header">
                    <i className="bi bi-lightning-fill"></i>
                    <h3>Quick Actions</h3>
                  </div>
                  <div className="actions-list">
                    <button className="action-btn primary">
                      <i className="bi bi-download"></i>
                      Download Policy PDF
                    </button>
                    <button className="action-btn secondary">
                      <i className="bi bi-credit-card"></i>
                      Pay Premium Now
                    </button>
                    <button className="action-btn outline">
                      <i className="bi bi-telephone"></i>
                      Contact Support
                    </button>
                    <button className="action-btn outline">
                      <i className="bi bi-chat-dots"></i>
                      Chat with Agent
                    </button>
                  </div>
                </div>

                {/* Policy Summary */}
                <div className="policy-summary-card">
                  <div className="card-header">
                    <h3>Policy Summary</h3>
                  </div>
                  <div className="summary-content">
                    <div className="summary-item">
                      <span className="summary-label">Premium:</span>
                      <span className="summary-value">${policy?.premiumAmount || '450.00'}</span>
                    </div>
                    <div className="summary-item">
                      <span className="summary-label">Policy Term:</span>
                      <span className="summary-value">{policy?.tenure || '2024'}</span>
                    </div>
                    <div className="summary-item">
                      <span className="summary-label">Coverage:</span>
                      <span className="summary-value">3 Members</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {activeTab === "documents" && (
            <div className="documents-content">
              <div className="content-card">
                <div className="card-header">
                  <i className="bi bi-file-earmark-text"></i>
                  <h3>Policy Documents</h3>
                  {/* <button className="upload-btn">
                    <i className="bi bi-upload"></i>
                    Upload Document
                  </button> */}
                </div>
                <div className="documents-grid">
                  {documents.map((doc, i) => (
                    <div key={i} className="document-card">
                      <div className="doc-icon">
                        <i className="bi bi-file-earmark-pdf"></i>
                      </div>
                      <div className="doc-info">
                        <div className="doc-title">{doc.title}</div>
                        <div className="doc-meta">
                          <span>{doc.type}</span>
                          <span>Uploaded: {doc.date}</span>
                          <span>{doc.size}</span>
                        </div>
                      </div>
                      <div className="doc-actions">
                        <button className="download-btn">
                          <i className="bi bi-download"></i>
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}

          {activeTab === "history" && (
            <div className="history-content">
              <div className="content-card">
                <div className="card-header">
                  <i className="bi bi-clock-history"></i>
                  <h3>Payment History</h3>
                </div>
                <div className="card-content">
                  <p className="text-muted">Payment history will be displayed here...</p>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PolicyViewPage;
